import type { TPaymentResponse } from "../models/payment";
import type { TPaymentData } from "../types";

const mapPaymentResponse = (response: TPaymentResponse): TPaymentData => ({
  isPaid: response.isPaid,
  paymentId: response.identifier,
  url: response.paymentData?.paymentUrl,
  method: response.paymentData?.method as "GET" | "POST",
  parameters: response.paymentData?.paymentParameters,
  redirect: response.redirect,
});
export default mapPaymentResponse;
